module.exports = __webpack_public_path__ + "img/personal.28551585.svg";